@if (pageErrMsg) {
  <fwc-alert class="global-alert-1" type="urgent" area="global" (fwc-alert-closed)="closeErrModal()">
    {{pageErrMsg}}</fwc-alert>
  }
  <!-- @if (pageSuccessMsg) {
  <fwc-alert class="global-alert-1" type="success" area="global"
    (fwc-alert-closed)="closeSuccessModal()">{{pageSuccessMsg}}</fwc-alert>
  } -->
<div *ngIf="!isResetPasswordSuccess">
<form [formGroup]="resetForm" (ngSubmit)="onChangePassword()" novalidate>
  <div class="fwc-container">
    <div class="fwc-row fwc-row-bm fwc-flex-column">
      <div class="fwc-input">
        <label for="NewPassword">New Password</label>
        <div class="sae-masked-input">
          <input formControlName="newPassword" name="NewPassword" id="NewPassword" type="password"
            maxlength="20"
            (keydown) = "onKey($event)"
            (keyup)="checkPasswordRules();validateFields()"
            attr.aria-invalid="{{submitted && form.newPassword.errors ? true : false}}"
            [attr.type]="createMask ? 'password':'text'"
            required/>
          <span class="sae-icon" [ngClass]="{'sae-icon-blind': createMask, 'sae-icon-eye': !createMask}" type="button" (click)="createMask = !createMask"></span>
        </div>
        @if (submitted && form.newPassword.hasError('required')) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" id="firstName_error">The new password field is required</span>
        }
        @if (passwordValidateError && submitted && !form.newPassword.hasError('required')) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" id="firstName_error">Invalid password</span>
        }
      </div>
      @if (showPasswordRules) {
        <div class="sae-password-rules">
          <ul>
            <li [ngClass]="{'rule-met' : ruleLowerCharMet, 'error-state' : passwordValidateError && submitted && !ruleLowerCharMet}">One lowercase character</li>
            <li [ngClass]="{'rule-met' : ruleNumberMet, 'error-state' : passwordValidateError && submitted && !ruleNumberMet}">One number</li>
            <li [ngClass]="{'rule-met' : ruleUpperCharMet, 'error-state' : passwordValidateError && submitted && !ruleUpperCharMet}">One uppercase character</li>
            <li [ngClass]="{'rule-met' : ruleSpecialMet, 'error-state' : passwordValidateError && submitted && !ruleSpecialMet}">One special character $!&#64;*?|</li>
            <li [ngClass]="{'rule-met' : rule8characterMet, 'error-state' : passwordValidateError && submitted && !rule8characterMet}">12 characters minimum</li>
          </ul>
        </div>
      }
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-input">
        <label for="retypePassword">Re-Type Password</label>
        <div class="sae-masked-input">
          <input formControlName="retypePassword" name="retypePassword" id="retypePassword" type="password"
            maxlength="20"
            (keyup)="validateFields()"
            (keydown.space)="$event.preventDefault()"
            attr.aria-invalid="{{submitted && form.retypePassword.errors ? true : false}}"
            [attr.type]="retypeMask ? 'password':'text'"
            required/>
          <span class="sae-icon" [ngClass]="{'sae-icon-blind': retypeMask, 'sae-icon-eye': !retypeMask}" type="button" (click)="retypeMask = !retypeMask"></span>
        </div>
        @if (submitted && passwordMatchError && !form.retypePassword.hasError('required')) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" id="firstName_error">The passwords do not match. Please re-enter your new password.</span>
        }
        @if (submitted && form.retypePassword.errors) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" id="firstName_error">The re-type password field is required.</span>
        }
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <button class="fwc-btn fwc-btn-primary font-elevance-medium">{{content.form.button}}</button>
    </div>
  </div>
</form>
</div>

<div *ngIf="isResetPasswordSuccess">
  <div class="fwc-container success-container">
    <div class="fwc-row fwc-row-bm fwc-flex-column">
      <div class="lock_icon">
      <svg width="51" height="56" viewBox="0 0 51 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.9167 25.25V14.5833C11.9167 11.0471 13.3214 7.65573 15.8219 5.15524C18.3224 2.65476 21.7138 1.25 25.25 1.25C28.7862 1.25 32.1776 2.65476 34.6781 5.15524C37.1786 7.65573 38.5833 11.0471 38.5833 14.5833V25.25M6.58333 25.25H43.9167C46.8622 25.25 49.25 27.6378 49.25 30.5833V49.25C49.25 52.1955 46.8622 54.5833 43.9167 54.5833H6.58333C3.63781 54.5833 1.25 52.1955 1.25 49.25V30.5833C1.25 27.6378 3.63781 25.25 6.58333 25.25Z"
          stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
       </div>
      <h3 class="paassword_update success-message">Your password has been updated.</h3>
    
    </div>
      <div class="success-text">Your password has been updated.</div>
      <div class="success-text">You'll be redirected in <span class="countdown-text">{{remainingTime}} seconds...</span></div>
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-12 sm-12">
          <button class="fwc-btn fwc-btn-primary font-elevance-login success-message" (click)="navigateTo()">Go TO Login</button>
        </div>
      </div>
  </div>
</div>
@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}

